export const smallPhone = '@media (max-width: 568px)';
export const phone = '@media (max-width: 768px)';
export const tablet = '@media (max-width: 992px)';
export const laptop = '@media (max-width: 1200px)';